// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"0b4aa855","239":"9a9dd01d"}[chunkId] + ".chunk.js";
};